/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Text, theme } from "@nordcloud/gnui";
import { Mailto } from "~/components";
import {
  StepCounter,
  StepWrapper,
} from "~/views/accounts/AddAccount/components/styles";

export function AwsFormSupportInfo() {
  return (
    <>
      <FlexContainer alignItems="flex-start">
        <StepCounter>?</StepCounter>
        <StepWrapper>Get Support</StepWrapper>
      </FlexContainer>
      <Text color={theme.color.text.text03}>
        If you are unable to complete the preceding steps, please contact us and
        we will assist you in resolving the issue. Please contact your Customer
        Success Manager or <Mailto email="products@nordcloudapp.com" /> for
        assistance.
      </Text>
    </>
  );
}
